exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 73
// module chunks = 0 1 2 3 4 5 6 7 8 10 16 17 18 19 20 26 27